import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export const ForYouSection: React.FC = () => {
  const points = ['Atendés pacientes con insomnio asociado a ansiedad, depresión, estrés, rumiación o fatiga emocional.', 'Querés diferenciar cuándo el insomnio está sostenido por ansiedad y cuándo por ánimo bajo o baja activación.', 'Tenés pacientes que no duermen porque la mente no se apaga.', 'Querés adaptar técnicas cognitivas y conductuales sin aplicar lo mismo en todos los casos.', 'Querés intervenir con más precisión clínica, más estructura y menos improvisación.'];
  return <section className="py-12 sm:py-16 bg-white px-4 sm:px-6 lg:px-8" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <h2 className="font-serif text-2xl sm:text-4xl font-bold text-navy mb-8 sm:mb-10 text-center" data-id="element-69">
          ESTE SISTEMA ES PARA VOS SI...
        </h2>

        <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3 sm:gap-y-4" data-id="element-70">
          {points.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="flex items-start gap-3" data-id="element-71">
              <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-accent shrink-0 mt-0.5" data-id="element-72" />
              <p className="text-gray-800 text-sm sm:text-base leading-snug" data-id="element-73">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};